module.exports = __webpack_public_path__ + "static/media/image-card-7.40e87771.png";